
export const FUNCTIONS = [
    {
        label:"Comparative",
        comparative: true,
    },
    {
        label: "Cumulative",
        comparative: false,
    }
];

interface Interval{
    name: string;
    firstKey: string;
    secondKey: string | undefined;
}

export const INTERVAL: Interval[] = [
    {name: "Time Slot", firstKey: "slot", secondKey: "date"},
    {name: "Date", firstKey: "date", secondKey: undefined},
    {name: "Month", firstKey: "month", secondKey: undefined},
    {name: "Station", firstKey: "station", secondKey: undefined},
    {name: "Area", firstKey: "sector", secondKey: undefined},
    {name: "State", firstKey: "state", secondKey: undefined},
    {name: "Source", firstKey: "source", secondKey: undefined},
];

export function getRajIntervals(): Interval[]{
    return INTERVAL.slice(0, 3);
}

export function getShowBrush(chartData: any[], selectedKey: Interval): boolean {
    if(selectedKey.firstKey === "slot"){
      return chartData.length > 96 * 1;
    }
    else {
        return chartData.length > 7;
    }
  }

 export function getBrushIndex(selectedKey: Interval): {startIndex: number, endIndex: number} {
    if(selectedKey.firstKey === "slot"){
      return {startIndex: 0, endIndex: 96 * 1};
    }
    else {
        return {startIndex: 0, endIndex: 7};
    }
  }

  export const RAJ_UNITS = ["MW", "MWh"];


 export const handleUnitChange = (selectedUnit: string, selectedKey: Interval, setSelectedUnit: any) => {
    
    setSelectedUnit(selectedUnit);
  }

  export const handleKeyChange = (index: number, setSelectedKey: any, setSelectedUnit: any) => {
    
    setSelectedKey(INTERVAL[index]);
  }